var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGarden(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#27A376",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2780_12415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2662 25.5181H10V26.69H11.2662V28.2014H10V29.3732H29.9998V28.2014H24.3877V23.2342H24.4996C25.4696 23.2342 26.2587 22.4451 26.2587 21.4751V21.3525H25.0868V21.4751C25.0868 21.7989 24.8234 22.0623 24.4996 22.0623H24.3877V18.6104H25.2519C26.1388 18.6104 26.8909 18.0222 27.1388 17.2156H27.7642C28.997 17.2156 30 16.2126 30 14.9798V14.965C30 13.9166 29.2746 13.0344 28.2994 12.7939C28.0561 11.5613 26.9669 10.6289 25.6639 10.6289H21.3305C20.0505 10.6289 18.9767 11.5288 18.7087 12.7292H18.4054C17.1726 12.7292 16.1696 13.7322 16.1696 14.965V14.9798C16.1696 16.2126 17.1726 17.2156 18.4054 17.2156H19.1358C19.354 17.9256 19.9629 18.4662 20.7105 18.5855V18.7761C20.7105 20.0741 21.7665 21.1302 23.0646 21.1302H23.2159V28.2014H20.2053V26.69H21.4715V25.5181H20.2053V21.3205H11.2662V25.5181ZM12.4381 24.5458H19.0334V25.5181H12.4381V24.5458ZM12.4381 26.69H19.0334V28.2014H12.4381V26.69ZM23.2158 19.9582H23.0645C22.4127 19.9582 21.8823 19.4279 21.8823 18.7761V18.6104H23.2158V19.9582Z",
    fill: "#27A376"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2780_12415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarden);
export default __webpack_public_path__ + "static/media/garden.b9e04eda5cafdecd98febdaf5bcecfbd.svg";
export { ForwardRef as ReactComponent };